import { createServiceFactory } from '@/services/factory'
import { createMockTenantService } from './tenant.mock'
import { createHttpTenantService } from './tenant.http'

export type { TenantService } from './tenant.service'

export const getTenantService = createServiceFactory(
  'tenant',
  createMockTenantService,
  createHttpTenantService
)
